import Typography from "@material-ui/core/Typography";
import {
  ThemeProvider as MuiThemeProvider,
  responsiveFontSizes,
} from "@material-ui/core/styles";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import Footer from "../Components/Layout/Footer";
import Logo from "../Components/Layout/Logo";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { Container } from "@material-ui/core";

let theme = createMuiTheme();
theme = responsiveFontSizes(theme);

const Terms = () => {
  return (
    <MuiThemeProvider theme={theme}>
      <div className="showcase">
        <Banner />
        <BasicTerms />
        <Footer />
      </div>
    </MuiThemeProvider>
  );
};

const BasicTerms = () => {
  return (
    <Container
      maxWidth="md"
      component="div"
      style={{ backgroundColor: "#fff", height: "auto",display:"flex",flexDirection:"column",marginTop:"1rem",padding:"2rem" }}
    >
      <Typography variant="h3">Basic Terms</Typography>
      <Typography variant="p">
        By using the studybud/studybud.io website and service you are agreeing
        to be bound by the following terms and conditions ("Terms of Use").
      </Typography>
      <br />
      <Typography variant="body1">
        <ol>
          <li>You must be 13 years or older to use this site.</li>
          <li>
            You are responsible for any activity that occurs under your
            username.
          </li>
          <li>You are responsible for keeping your password secure.</li>
          <li>
            You must not abuse, harass, threaten, impersonate or intimidate
            other Studybud users.
          </li>
          <li>
            You are solely responsible for your conduct and any data, text,
            information, screen names, graphics, photos, profiles, audio and
            video clips, links ("Content") that you submit, post, and display on
            the Studybud service.
          </li>
          <li>
            You must not modify, adapt or hack Studybud or modify another
            website so as to falsely imply that it is associated with Studybud.
          </li>
          <li>
            You must not crawl, scrape, or otherwise cache any content from
            Studybud including but not limited to user profiles and posts.
          </li>
          <li>
            You must not transmit any worms or viruses or any code of a
            destructive nature.
          </li>
          <li>
            You may not use the Studybud service for any illegal or unauthorized
            purpose.
          </li>
          <li>
            Violation of any of these agreements will result in the termination
            of your Studybud account.
          </li>
        </ol>
      </Typography>
    </Container>
  );
};

const Banner = () => {
  return (
    <div className="banner">
      <AppBar color="inherit" position="fixed">
        <Toolbar
          component="div"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Logo />
          <Typography edge="start" variant="h4" style={{ fontWeight: "bold" }}>
            Terms of Use
          </Typography>
          <Button
            variant="outlined"
            size="small"
            color="inherit"
            component={Link}
            to="/login"
          >
            Log in
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
};

export default Terms;
